import React from 'react';

const DocumentSelector = ({ 
  documentCount, 
  setDocumentCount, 
  onPriceCalculate, 
  config,
  loadingConfig 
}) => {
  return (
    <div className="mb-4">
      <label className="form-label fw-semibold mb-3 text-center d-block">
        <i className="bi bi-basket3 me-2 text-primary"></i>
        <span className="text-primary">¿Cuántos documentos necesitas?</span>
      </label>
      
      {/* Cantidad seleccionada centrada */}
      <div className="text-center mb-3">
        <div className="h2 text-primary fw-bold">{documentCount.toLocaleString()}</div>                  
      </div>

      {/* Slider centrado */}
      <div className="px-4">
        <input
          type="range"
          className="form-range"
          min={config?.min_documents || 100}
          max={config?.max_documents || 5000}
          step={config?.document_step || 100}
          value={documentCount}
          onChange={(e) => setDocumentCount(parseInt(e.target.value))}
        />
        {/* Referencias de valores en el slider */}
        <div className="d-flex justify-content-between small text-muted position-relative mt-1">
          <span>{(config?.min_documents || 100).toLocaleString()}</span>
          <span className="position-absolute" style={{left: '25%', transform: 'translateX(-50%)'}}>
            {Math.round(((config?.min_documents || 100) + ((config?.max_documents || 5000) - (config?.min_documents || 100)) * 0.25) / 100) * 100}
          </span>
          <span className="position-absolute" style={{left: '50%', transform: 'translateX(-50%)'}}>
            {Math.round(((config?.min_documents || 100) + (config?.max_documents || 5000)) / 2 / 100) * 100}
          </span>
          <span className="position-absolute" style={{left: '75%', transform: 'translateX(-50%)'}}>
            {Math.round(((config?.min_documents || 100) + ((config?.max_documents || 5000) - (config?.min_documents || 100)) * 0.75) / 100) * 100}
          </span>
          <span>{(config?.max_documents || 5000).toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default DocumentSelector;
